export enum SubjectReviewStatus {
    Added = 0,
    Removed = 1,
    Reviewed = 2,
}
